import React from 'react';

import styled from '@emotion/styled';

import { useAppSelector } from '../../redux/store';
import { getTimeOfDayGreeting } from '../../utils/utils';
import FullScreenBanner from '../Banner/FullScreenBanner';

interface PageLayoutProps {
  children?: any;
  // title?: string;
}

const PageLayout: React.FC<PageLayoutProps> = ({ children }) => {
  const { authData } = useAppSelector((state) => state.auth);

  return (
    <Container>
      <FullScreenBanner />
      {
        <Title>
          {getTimeOfDayGreeting()}, {authData?.user?.firstName}
          {`${authData?.user?.lastName ? ` ${authData.user.lastName}` : ''}`}.
        </Title>
      }
      {children}
    </Container>
  );
};

export default PageLayout;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  /* border: 1px solid red; */
  padding: 20px;
`;

const Title = styled.div`
  font-size: 20px;
  font-weight: 500;
  color: #6b7280;
`;
